// MicrosoftLoginButton.jsx
import React from 'react';
import SocialLoginButton from '../SocialLoginButton/SocialLoginButton';

export default function MicrosoftLoginButton() {
  const clientId = 'a75da378-d21d-4525-a584-8c372e340948';
  const redirectUri = encodeURIComponent('https://ws.brandful.com.br/integracoes/entraid'); // encode obrigatório
  const scope = encodeURIComponent('openid email profile offline_access User.Read');
  const responseType = 'code';
  const responseMode = 'query'; // ou 'form_post', dependendo do backend
  const prompt = 'select_account'; // ou 'consent'

  // Endpoint 'common' permite login de qualquer tenant
  const redirectUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&response_type=${responseType}&redirect_uri=${redirectUri}&response_mode=${responseMode}&scope=${scope}&prompt=${prompt}`;

  console.log('MicrosoftLoginButton renderizado');

  return (
    <SocialLoginButton
      label="Entrar com Microsoft"
      redirectUrl={redirectUrl}
    />
  );
}
